module.exports = __webpack_public_path__ + "img/aParty_091123_B.31ecc1fb.jpg";